
import React from 'react';
import { TeamMemberItemProps } from './types';

const TeamMemberItem = ({ member, onClick }: TeamMemberItemProps) => {
  return (
    <div 
      className="flex items-center gap-2 py-1.5 px-2 rounded-md text-xs hover:bg-sidebar-accent/30 cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        onClick(member.id, member.name);
      }}
    >
      <div className="h-5 w-5 rounded-full bg-accent/10 text-xs flex items-center justify-center">
        {member.name.slice(0, 2)}
      </div>
      <div>
        <p className="text-xs">{member.name}</p>
        <p className="text-[10px] text-muted-foreground">{member.role}</p>
      </div>
    </div>
  );
};

export default TeamMemberItem;
